import { PrivacyContent } from '../../components/legal/PrivacyContent';
import { LegalPage } from './LegalPage';

export function PrivacyPage() {
  return <LegalPage doc="privacy">{(lang) => <PrivacyContent lang={lang} />}</LegalPage>;
}

export default PrivacyPage;
